import {Role} from '@linx-security/api-specs';

export type UserPrivilegeLevelRole = {
  isAdmin: boolean;
  isReviewer: boolean;
  isAppOwner: boolean;
  isAccessUser: boolean;
  isCampaignOwner: boolean;
  role: Role | null;
  isLinxConfigurationAdmin: boolean;
  isReadOnlyAdmin: boolean;
  isInventoryReader: boolean;
};

const PRIVILEGE_LEVEL: Array<Role> = [
  Role.Admin,
  Role.AppOwner,
  Role.CampaignOwner,
  Role.ReadOnlyAdmin,
  Role.AccessUser,
  Role.Reviewer,
  Role.RegularUser,
  Role.LinxConfigurationAdmin,
];
export const getHighestPrivilegeRole = (userRoles: Array<string> | undefined): UserPrivilegeLevelRole => {
  const highestPrivilegeRole = (): Role | null => {
    if (!userRoles) {
      return null;
    }
    const roleIndex = PRIVILEGE_LEVEL.findIndex(role => userRoles.includes(role));
    const role = roleIndex !== -1 ? PRIVILEGE_LEVEL[roleIndex] : null;
    return role;
  };
  const role = highestPrivilegeRole();
  return {
    role,
    isAdmin: role === Role.Admin,
    isReviewer: role === Role.Reviewer,
    isAppOwner: role === Role.AppOwner,
    isCampaignOwner: role === Role.CampaignOwner,
    isAccessUser: role === Role.AccessUser,
    isLinxConfigurationAdmin: role === Role.LinxConfigurationAdmin,
    isReadOnlyAdmin: role === Role.ReadOnlyAdmin,
    isInventoryReader: !!userRoles?.includes(Role.InventoryReader),
  };
};

/** Client-side Linx admin detection by email pattern, used for RUM session-replay suppression. */
export const isLinxAdminEmail = (email?: string | null): boolean => {
  const normalized = email?.trim().toLowerCase() ?? ``;
  return normalized.endsWith(`@linx.admin`) || normalized.startsWith(`linxadmin@`);
};
